/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OfferDetailedResponse } from '../../models/offer-detailed-response';

export interface GetOfferDetailsByOfferRequestIdAndOfferId$Params {
  offerRequestId: string;
  offerId: string;
}

export function getOfferDetailsByOfferRequestIdAndOfferId(http: HttpClient, rootUrl: string, params: GetOfferDetailsByOfferRequestIdAndOfferId$Params, context?: HttpContext): Observable<StrictHttpResponse<OfferDetailedResponse>> {
  const rb = new RequestBuilder(rootUrl, getOfferDetailsByOfferRequestIdAndOfferId.PATH, 'get');
  if (params) {
    rb.path('offerRequestId', params.offerRequestId, {});
    rb.path('offerId', params.offerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OfferDetailedResponse>;
    })
  );
}

getOfferDetailsByOfferRequestIdAndOfferId.PATH = '/offers/requests/{offerRequestId}/offers/{offerId}';
